import React from 'react';
import { Button, Spinner } from 'reactstrap';
import { checkMarkIcon } from '../../../assets/icons';

export const SubmitButton = ({ isLoading, text, ...props }) => (
    isLoading ? (
        <Button
            className="dt1520-button speakers-button default-button"
            outline color="secondary"
            disabled
            draggable="false"
            {...props}>
            <Spinner as="span" size="sm" animation="grow" className="loader me-2" />
            {text}
        </Button>
    ) : (
        <Button
            className="dt1520-button active-dt1520-button speakers-button default-button"
            outline
            type="submit"
            draggable="false"
            {...props}>
            <img src={checkMarkIcon} alt="✓" className='logo-dt1520-button' />
            {text}
        </Button>
    )
);